/* eslint-disable */
import * as React from 'react';
const SvgDeleteCircle = (props) => (React.createElement("svg", { viewBox: "0 0 18 18", width: "1em", height: "1em", ...props },
    React.createElement("circle", { cx: 9, cy: 9, fill: "#7e7e7e", r: 9 }),
    React.createElement("g", { fill: "none", stroke: "#fff", strokeMiterlimit: 10, strokeWidth: 2 },
        React.createElement("path", { d: "M4.8 4.8l8.4 8.4M13.2 4.8l-8.4 8.4" }))));
export default SvgDeleteCircle;
/* eslint-enable */
